export const RADICAL = 'radical';
export const KANJI = 'kanji';
export const VOCABULARY = 'vocabulary';
export const ALL = 'all';
